import React from 'react'

import Page from './src/components/Page'

import { loadPosthog } from './src/util/posthog'

export function onClientEntry() {
  loadPosthog()
}

export function wrapPageElement({ element, props }) {
  return <Page {...props}>{element}</Page>
}
